var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDoubleArrowUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m60.288 35.086-20.391-20.31c-4.357-4.34-11.437-4.34-15.794 0l-20.39 20.31L0 31.388l20.39-20.31c6.405-6.38 16.815-6.38 23.22 0L64 31.387l-3.712 3.698Zm-36.185 3.31c4.357-4.34 11.437-4.34 15.794 0l20.39 20.31L64 55.008l-20.39-20.31c-6.405-6.38-16.815-6.38-23.22 0L0 55.008l3.712 3.698 20.391-20.31Z",
  fill: "currentColor"
})));
export default SvgDoubleArrowUp;